// Row component used by the mapping function in WeatherTable.js
import React from 'react';


function LinksRow({websx}) {
    
    return (
  
            <tr>
                <td className='type-web'>{websx.type}</td>
                <td className='web-link' > <a href={`${websx.wx_link}`} target='_blank' rel="noopener noreferrer">
                    View Link
                    </a> 
                    </td>
               
            </tr> 
            
    );
} 

export default LinksRow;